import {arrayToSet} from '../../atUtils'
import {TasksTabs} from './constants'

export default function({
    actionTypes: {
        TASK_PANEL_LOADING_SET,
        OPEN_TASK_SET,
        TASK_INFO_SET,
        TASK_PANEL_ERRORS_ADD,
        TASK_PANEL_ERRORS_SET,
        TASK_PANEL_ERRORS_REMOVE,
        TASK_PANEL_SHOWN_SET,
        TASK_PANEL_LOADED_SET,
        TASK_PANEL_TAB_SET,
        TASK_PANEL_LAST_TAB_SET,
        NEED_INITIALIZE_FOCUS_SET,
    }
}) {
    return {
        initialState: {
            panelLoading: false,
            loaded: false,
            shown: false,
            taskInfo: {
                workflowStatusId: 0,
                creationTimestamp: null,
                completed: false,
                name: '',
                deadline: null,
                typeOfWorkId: 0,
                estimatedTime: null,
                spentTime: 0,
                description: '',
            },
            updatingState: {
                nameUpdating: false,
                deadlineUpdating: false,
                typeOfWorkUpdating: false,
                estimateUpdating: false,
                descriptionUpdating: false
            },

            currentTabKey: TasksTabs.DETAILS_TAB,
            lastSelectedTabKey: TasksTabs.DETAILS_TAB,
            isNeedInitializeFocus: false,

            errors: {},
        },
        handlers: {
            [TASK_PANEL_LOADING_SET]: (state, {payload: panelLoading}) => ({...state, panelLoading}),
            [TASK_PANEL_LOADED_SET]: (state, {payload: loaded}) => ({...state, loaded}),
            [OPEN_TASK_SET]: (state, {payload: openTaskId}) => ({...state, openTaskId}),
            [TASK_PANEL_TAB_SET]: (state, {payload: currentTabKey}) => ({...state, currentTabKey}),
            [TASK_PANEL_LAST_TAB_SET]: (state, {payload: lastSelectedTabKey}) => ({...state, lastSelectedTabKey}),
            [TASK_INFO_SET]: (state, {payload: changedData}) => ({
                ...state,
                taskInfo: {...state.taskInfo, ...changedData}
            }),
            [TASK_PANEL_SHOWN_SET]: (state, {payload: shown}) => ({...state, shown, isNeedInitializeFocus: shown}),
            [NEED_INITIALIZE_FOCUS_SET]: (state, {payload: isNeedInitializeFocus}) => ({...state, isNeedInitializeFocus: isNeedInitializeFocus}),
            [TASK_PANEL_ERRORS_ADD]: (state, {payload: errors}) => ({
                ...state,
                errors: {...state.errors, ...arrayToSet(errors)}
            }),
            [TASK_PANEL_ERRORS_SET]: (state, {payload: errors}) => ({
                ...state,
                errors: {...arrayToSet(errors)}
            }),
            [TASK_PANEL_ERRORS_REMOVE]: (state, {payload: deletedErrors}) => {
                const deletedErrorsSet = arrayToSet(deletedErrors)
                const errors = Object.keys(state.errors)
                                     .filter(key => !deletedErrorsSet[key])
                                     .reduce((res, key) => (res[key] = state.errors[key], res), {})
                return {
                    ...state,
                    errors: errors,
                }
            },
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/reducerGenerator.js